export default __webpack_public_path__ + "images/51702d1c7861df428949882bf2e3b5a6-3_tablet_1067x470.jpg";